(function () {

  'use strict';


  /* =========================================
     SETTINGS
  ========================================= */

  const COUPON_CODE = 'TADKAPAN';

  const GIFT_VARIANT_ID = 41854874779781;

  const MINIMUM_PRODUCTS = 1;

  let processing = false;


  /* =========================================
     GET CART
  ========================================= */

  async function getCart() {

    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    });


    if (!response.ok) {
      throw new Error('Cart could not be loaded');
    }


    return await response.json();

  }


  /* =========================================
     COUNT NORMAL PRODUCTS
     
     TADKA PAN IS NOT COUNTED
  ========================================= */

  function getEligibleProductCount(cart) {

    if (!cart || !cart.items) {
      return 0;
    }


    return cart.items.reduce(function (total, item) {

      /*
       * Don't count Tadka Pan
       */

      if (
        Number(item.variant_id) ===
        Number(GIFT_VARIANT_ID)
      ) {
        return total;
      }


      return total +
        Number(item.quantity || 0);

    }, 0);

  }


  /* =========================================
     CHECK TADKA PAN EXISTS
  ========================================= */

  function giftExists(cart) {

    if (!cart || !cart.items) {
      return false;
    }


    return cart.items.some(function (item) {

      return Number(item.variant_id) ===
        Number(GIFT_VARIANT_ID);

    });

  }


  /* =========================================
     FIND DISCOUNT BOX
  ========================================= */

  function getDiscountBox() {

    return document.getElementById(
      'discounts'
    );

  }


  /* =========================================
     START APPLY BUTTON LOADER
  ========================================= */

  function startCouponLoader(button) {

    if (!button) {
      return;
    }


    /*
     * Save original button content
     */

    if (
      !button.dataset.hsgOriginalText
    ) {

      button.dataset.hsgOriginalText =
        button.innerHTML;

    }


    button.disabled = true;


    button.classList.add(
      'hsg-coupon-applying'
    );


    button.innerHTML = `
      <span class="hsg-coupon-loader"></span>
      Applying...
    `;

  }


  /* =========================================
     STOP APPLY BUTTON LOADER
  ========================================= */

  function stopCouponLoader(button) {

    if (!button) {
      return;
    }


    button.disabled = false;


    button.classList.remove(
      'hsg-coupon-applying'
    );


    if (
      button.dataset.hsgOriginalText
    ) {

      button.innerHTML =
        button.dataset.hsgOriginalText;

      delete button.dataset.hsgOriginalText;

    }

  }


  /* =========================================
     SHOW MINIMUM PRODUCT MESSAGE
  ========================================= */

  function showMinimumProductMessage() {

    /*
     * Remove old duplicate
     */

    const existing =
      document.querySelector(
        '.hsg-minimum-product-message'
      );


    if (existing) {
      return;
    }


    const discountBox =
      getDiscountBox();


    if (!discountBox) {

      console.log(
        'Discount box not found'
      );

      return;

    }


    const message =
      document.createElement('div');


    message.className =
      'hsg-minimum-product-message';


    message.innerHTML = `
      <span>
        🛒 Add 1 more product to unlock your FREE Tadka Pan.
      </span>
    `;


    discountBox.parentNode.insertBefore(
      message,
      discountBox
    );

  }


  /* =========================================
     REMOVE MINIMUM PRODUCT MESSAGE
  ========================================= */

  function removeMinimumProductMessage() {

    document
      .querySelectorAll(
        '.hsg-minimum-product-message'
      )
      .forEach(function (message) {

        message.remove();

      });

  }


  /* =========================================
     SHOW FREE GIFT MESSAGE
  ========================================= */

  function showGiftMessage() {

    /*
     * Don't create duplicate
     */

    if (
      document.querySelector(
        '.hsg-free-gift-message'
      )
    ) {

      return;

    }


    const discountBox =
      getDiscountBox();


    if (!discountBox) {
      return;
    }


    const message =
      document.createElement('div');


    message.className =
      'hsg-free-gift-message';


    message.innerHTML = `
      <span class="hsg-free-gift-text">
        🎁 Free Gift Included. Coupon Applied: TADKAPAN
        </span>


      <button
        type="button"
        class="hsg-free-gift-cancel">
        Cancel
      </button>
    `;


    discountBox.parentNode.insertBefore(
      message,
      discountBox
    );


    /*
     * Cancel button
     */

    const cancelButton =
      message.querySelector(
        '.hsg-free-gift-cancel'
      );


    cancelButton.addEventListener(
      'click',
      async function () {

        this.disabled = true;

        this.textContent =
          'Removing...';


        try {

          const cart =
            await getCart();


          const giftItem =
            cart.items.find(function (item) {

              return Number(
                item.variant_id
              ) ===
              Number(
                GIFT_VARIANT_ID
              );

            });


          if (giftItem) {

            await fetch(
              '/cart/change.js',
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'
                },

                body: JSON.stringify({
                  id: giftItem.key,
                  quantity: 0
                })
              }
            );

          }


          /*
           * Refresh cart page
           */

          window.location.href =
            '/cart';


        } catch (error) {

          console.error(
            'Gift removal error:',
            error
          );


          this.disabled = false;

          this.textContent =
            'Cancel';

        }

      }
    );

  }


  /* =========================================
     CHECK COUPON APPLIED
  ========================================= */

  async function checkCouponApplied() {

    try {

      const cart =
        await getCart();


      let applied = false;


      /* -----------------------------------------
         CART LEVEL DISCOUNT
      ----------------------------------------- */

      if (
        cart.cart_level_discount_applications
      ) {

        applied =
          cart.cart_level_discount_applications.some(
            function (discount) {

              return String(
                discount.title || ''
              )
                .trim()
                .toUpperCase() ===
                COUPON_CODE;

            }
          );

      }


      /* -----------------------------------------
         LINE LEVEL DISCOUNT
      ----------------------------------------- */

      if (
        !applied &&
        cart.items
      ) {

        cart.items.forEach(
          function (item) {

            if (
              item.line_level_discount_allocations
            ) {

              item
                .line_level_discount_allocations
                .forEach(
                  function (allocation) {

                    const title =
                      allocation
                        .discount_application &&
                      allocation
                        .discount_application
                        .title;


                    if (
                      String(
                        title || ''
                      )
                        .trim()
                        .toUpperCase() ===
                      COUPON_CODE
                    ) {

                      applied = true;

                    }

                  }
                );

            }

          }
        );

      }


      /* -----------------------------------------
         VISIBLE DISCOUNT TEXT
      ----------------------------------------- */

      if (!applied) {

        document
          .querySelectorAll(
            '.cart__discount'
          )
          .forEach(
            function (element) {

              if (
                element.textContent
                  .toUpperCase()
                  .includes(
                    COUPON_CODE
                  )
              ) {

                applied = true;

              }

            }
          );

      }


      /* -----------------------------------------
         IF COUPON APPLIED
      ----------------------------------------- */

      if (applied) {

        const productCount =
          getEligibleProductCount(
            cart
          );


        /*
         * Less than 2 products
         */

        if (
          productCount <
          MINIMUM_PRODUCTS
        ) {

          showMinimumProductMessage();

          return;

        }


        removeMinimumProductMessage();

        showGiftMessage();

      }


    } catch (error) {

      console.log(
        'Coupon verification error:',
        error
      );

    }

  }


  /* =========================================
     ADD TADKA PAN
  ========================================= */

  async function addGift(
    applyButton = null
  ) {

    if (processing) {
      return;
    }


    processing = true;


    /*
     * Start loader immediately
     */

    startCouponLoader(
      applyButton
    );


    try {

      const cart =
        await getCart();


      /* -----------------------------------------
         COUNT NORMAL PRODUCTS
      ----------------------------------------- */

      const productCount =
        getEligibleProductCount(
          cart
        );


      console.log(
        'Normal products:',
        productCount
      );


      /* -----------------------------------------
         MINIMUM 2 PRODUCTS
      ----------------------------------------- */

      if (
        productCount <
        MINIMUM_PRODUCTS
      ) {

        console.log(
          '❌ Add 1 more product'
        );


        showMinimumProductMessage();


        stopCouponLoader(
          applyButton
        );


        processing = false;

        return;

      }


      /*
       * Remove warning
       */

      removeMinimumProductMessage();


      /* -----------------------------------------
         CHECK TADKA PAN
      ----------------------------------------- */

      if (
        giftExists(cart)
      ) {

        console.log(
          '🎁 Tadka Pan already exists'
        );


        await applyDiscount();


        stopCouponLoader(
          applyButton
        );


        return;

      }


      /* -----------------------------------------
         ADD TADKA PAN
      ----------------------------------------- */

      console.log(
        '🎁 Adding Tadka Pan...'
      );


      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body: JSON.stringify({

              items: [
                {
                  id:
                    GIFT_VARIANT_ID,

                  quantity: 1
                }
              ]

            })

          }
        );


      if (!response.ok) {

        console.error(
          'Unable to add Tadka Pan:',
          await response.text()
        );


        stopCouponLoader(
          applyButton
        );


        processing = false;

        return;

      }


      console.log(
        '✅ Tadka Pan added'
      );


      /* -----------------------------------------
         APPLY DISCOUNT
      ----------------------------------------- */

      await applyDiscount();


      /*
       * Stop loader
       */

      stopCouponLoader(
        applyButton
      );


    } catch (error) {

      console.error(
        'Tadka Pan error:',
        error
      );


      stopCouponLoader(
        applyButton
      );


      processing = false;

    }

  }


  /* =========================================
     APPLY SHOPIFY DISCOUNT
  ========================================= */

  async function applyDiscount() {

    console.log(
      '🏷️ Applying ' +
      COUPON_CODE
    );


    try {

      const discountUrl =
        '/discount/' +
        encodeURIComponent(
          COUPON_CODE
        ) +
        '?redirect=/cart';


      const response =
        await fetch(
          discountUrl,
          {
            method: 'GET',

            credentials:
              'same-origin',

            redirect:
              'follow',

            cache:
              'no-store'
          }
        );


      console.log(
        'Discount response:',
        response.status
      );


      /*
       * Refresh cart
       */

      await refreshCartDrawer();


      /*
       * Check discount after refresh
       */

      setTimeout(
        function () {

          checkCouponApplied();

        },
        300
      );


    } catch (error) {

      console.error(
        'Discount error:',
        error
      );


      /*
       * Still refresh cart
       */

      await refreshCartDrawer();

    }

  }


  /* =========================================
     REFRESH CART DRAWER
  ========================================= */

  async function refreshCartDrawer() {

    try {

      const cart =
        await getCart();


      console.log(
        '🛒 Updated cart:',
        cart
      );


      /* -----------------------------------------
         UPDATE CART COUNT
      ----------------------------------------- */

      document
        .querySelectorAll(
          '[data-cart-count], .cart-count, .cart__count'
        )
        .forEach(
          function (element) {

            if (
              cart.item_count !==
              undefined
            ) {

              element.textContent =
                cart.item_count;

            }

          }
        );


      /* -----------------------------------------
         CART DRAWER
      ----------------------------------------- */

      const cartDrawer =
        document.querySelector(
          'cart-drawer'
        );


      if (
        cartDrawer &&
        typeof cartDrawer.renderContents ===
        'function'
      ) {

        try {

          const sections =
            await fetch(
              '/?sections=cart-drawer,cart-icon-bubble',
              {
                headers: {
                  'Accept':
                    'application/json'
                }
              }
            )
              .then(
                function (res) {
                  return res.json();
                }
              );


          /* ---------------------------------------
             CART DRAWER HTML
          --------------------------------------- */

          if (
            sections &&
            sections[
              'cart-drawer'
            ]
          ) {

            cartDrawer.innerHTML =
              sections[
                'cart-drawer'
              ];

          }


          /* ---------------------------------------
             CART ICON
          --------------------------------------- */

          if (
            sections &&
            sections[
              'cart-icon-bubble'
            ]
          ) {

            const bubble =
              document.querySelector(
                '#cart-icon-bubble'
              );


            if (bubble) {

              bubble.innerHTML =
                sections[
                  'cart-icon-bubble'
                ];

            }

          }

        } catch (error) {

          console.log(
            'Cart drawer refresh skipped:',
            error
          );

        }

      }


      /* -----------------------------------------
         DISPATCH CART EVENTS
      ----------------------------------------- */

      const drawer =
        document.querySelector(
          'cart-drawer, .cart-drawer, #CartDrawer, [data-cart-drawer]'
        );


      if (drawer) {

        document.dispatchEvent(
          new CustomEvent(
            'cart:refresh',
            {
              detail: {
                cart:
                  cart
              }
            }
          )
        );


        document.dispatchEvent(
          new CustomEvent(
            'cart:updated',
            {
              detail: {
                cart:
                  cart
              }
            }
          )
        );

      }


      document.dispatchEvent(
        new CustomEvent(
          'cart:change',
          {
            detail: {
              cart:
                cart
            }
          }
        )
      );


    } catch (error) {

      console.error(
        'Cart refresh error:',
        error
      );

    }

  }


  /* =========================================
     FIND COUPON INPUT
  ========================================= */

  function findCouponInput(
    container
  ) {

    const root =
      container ||
      document;


    const inputs =
      root.querySelectorAll(
        'input'
      );


    for (
      const input of inputs
    ) {

      const name =
        (
          input.name ||
          ''
        ).toLowerCase();


      const id =
        (
          input.id ||
          ''
        ).toLowerCase();


      const placeholder =
        (
          input.placeholder ||
          ''
        ).toLowerCase();


      const type =
        (
          input.type ||
          ''
        ).toLowerCase();


      /* -----------------------------------------
         IGNORE UNUSABLE INPUTS
      ----------------------------------------- */

      if (

        type === 'hidden' ||
        type === 'number' ||
        type === 'checkbox' ||
        type === 'radio'

      ) {

        continue;

      }


      /* -----------------------------------------
         DETECT COUPON INPUT
      ----------------------------------------- */

      if (

        name.includes(
          'discount'
        ) ||

        name.includes(
          'coupon'
        ) ||

        name.includes(
          'promo'
        ) ||

        name.includes(
          'code'
        ) ||

        id.includes(
          'discount'
        ) ||

        id.includes(
          'coupon'
        ) ||

        id.includes(
          'promo'
        ) ||

        placeholder.includes(
          'discount'
        ) ||

        placeholder.includes(
          'coupon'
        ) ||

        placeholder.includes(
          'promo'
        )

      ) {

        return input;

      }

    }


    return null;

  }


  /* =========================================
     DETECT APPLY BUTTON
  ========================================= */

  function isCouponButton(
    button
  ) {

    if (!button) {
      return false;
    }


    /* -----------------------------------------
       THEME ATTRIBUTE
      ----------------------------------------- */

    if (
      button.matches(
        '[data-apply-discount]'
      )
    ) {

      return true;

    }


    const text =
      (
        button.innerText ||
        button.textContent ||
        button.value ||
        ''
      )
        .trim()
        .toLowerCase();


    const aria =
      (
        button.getAttribute(
          'aria-label'
        ) || ''
      )
        .toLowerCase();


    const form =
      button.closest(
        'form'
      );


    /* -----------------------------------------
       FORM HAS COUPON INPUT
      ----------------------------------------- */

    if (form) {

      const couponInput =
        findCouponInput(
          form
        );


      if (couponInput) {

        return true;

      }

    }


    /* -----------------------------------------
       BUTTON TEXT
      ----------------------------------------- */

    if (

      text === 'apply' ||

      text.includes(
        'apply coupon'
      ) ||

      text.includes(
        'apply code'
      ) ||

      text.includes(
        'apply discount'
      ) ||

      aria.includes(
        'apply coupon'
      ) ||

      aria.includes(
        'apply discount'
      )

    ) {

      return true;

    }


    return false;

  }


  /* =========================================
     HANDLE APPLY BUTTON CLICK
  ========================================= */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          'button, input[type="submit"]'
        );


      if (!button) {
        return;
      }


      if (
        !isCouponButton(
          button
        )
      ) {

        return;

      }


      const form =
        button.closest(
          'form'
        );


      const couponInput =
        findCouponInput(
          form
        );


      if (!couponInput) {

        console.log(
          'Coupon input not found'
        );

        return;

      }


      const code =
        (
          couponInput.value ||
          ''
        )
          .trim()
          .toUpperCase();


      console.log(
        'Coupon entered:',
        code
      );


      /*
       * Only handle our coupon
       */

      if (
        code !==
        COUPON_CODE
      ) {

        return;

      }


      /*
       * Stop theme's default coupon handler
       */

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      console.log(
        '🎁 TADKAPAN detected'
      );


      /*
       * Pass Apply button
       * so loader can appear
       */

      addGift(
        button
      );

    },
    true
  );


  /* =========================================
     HANDLE FORM SUBMIT
  ========================================= */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target;


      if (!form) {
        return;
      }


      const couponInput =
        findCouponInput(
          form
        );


      if (!couponInput) {
        return;
      }


      const code =
        (
          couponInput.value ||
          ''
        )
          .trim()
          .toUpperCase();


      if (
        code !==
        COUPON_CODE
      ) {

        return;

      }


      /*
       * Find submit button
       */

      const submitButton =
        form.querySelector(
          'button[type="submit"], input[type="submit"], button'
        );


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      console.log(
        '🎁 TADKAPAN form submitted'
      );


      addGift(
        submitButton
      );

    },
    true
  );


  /* =========================================
     ENTER KEY
  ========================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key !==
        'Enter'
      ) {

        return;

      }


      const input =
        event.target;


      if (
        !input ||
        input.tagName !==
        'INPUT'
      ) {

        return;

      }


      const form =
        input.closest(
          'form'
        );


      if (!form) {
        return;
      }


      const couponInput =
        findCouponInput(
          form
        );


      if (
        !couponInput ||
        couponInput !== input
      ) {

        return;

      }


      const code =
        (
          input.value ||
          ''
        )
          .trim()
          .toUpperCase();


      if (
        code !==
        COUPON_CODE
      ) {

        return;

      }


      const submitButton =
        form.querySelector(
          'button[type="submit"], input[type="submit"], button'
        );


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      console.log(
        '🎁 TADKAPAN entered with Enter'
      );


      addGift(
        submitButton
      );

    },
    true
  );


  /* =========================================
     INITIAL CHECK
  ========================================= */

  function initializeGiftSystem() {

    checkCouponApplied();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeGiftSystem
    );

  } else {

    initializeGiftSystem();

  }


})();
